import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { authenticatedRoute } from "../_authenticated.js";

const portalUsersSearchSchema = z.object({
  /** Jump to… / ⌘K opens the invite dialog. */
  invite: z.coerce.boolean().optional().catch(undefined),
});

export const portalUsersRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/portal-users",
  validateSearch: (search: Record<string, unknown>) => portalUsersSearchSchema.parse(search),
  component: lazyRouteComponent(() => import("./portal-users.page.js"), "PortalUsersPage"),
});
